<template>
    <UOM></UOM>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UOM = defineAsyncComponent(() =>
    import("../../../components/Purchasing/UOM/UOM.vue")
);
export default {
    components: { UOM, AuthLayout },
};
</script>
